(() => {
  function init() {
    const modal = document.querySelector('dialog[data-bis-modal]');
    if (!modal || modal.dataset.initialized) return;
    modal.dataset.initialized = 'true';
    const form = modal.querySelector('[data-notify-form]');
    const email = modal.querySelector('[data-restock-email]');
    const consent = modal.querySelector('[data-bis-consent]');
    const submit = modal.querySelector('[data-restock-submit]');
    const fieldError = modal.querySelector('[data-restock-field-error]');
    const requestError = modal.querySelector('[data-restock-error]');
    const drafts = new Map();
    const requests = new Map();
    const accepted = new Set();
    let state = null;
    let trigger = null;
    let version = 0;
    let previousOverflow = '';
    function emit(name, extra = {}) {
      document.dispatchEvent(new CustomEvent(name, {detail: {source: state?.source, variant_id: state?.variantId, ...window.HinokPairsAB?.properties(), ...extra}}));
    }
    function save() {
      if (state) { state.email = email.value; state.consent = !!consent?.checked; }
    }
    function render() {
      const success = state?.status === 'success';
      modal.querySelector('[data-restock-heading]').textContent = modal.querySelector('[data-restock-heading]').dataset[success ? 'success' : 'default'];
      modal.querySelector('[data-restock-body]').textContent = modal.querySelector('[data-restock-body]').dataset[success ? 'success' : 'default'];
      modal.querySelector('[data-restock-product]').textContent = state?.title || '';
      modal.querySelector('[data-restock-volume]').textContent = state?.volume || '';
      email.value = state?.email || '';
      if (consent) consent.checked = !!state?.consent;
      form.hidden = success;
      modal.querySelector('[data-restock-success]').hidden = !success;
      modal.querySelector('[data-restock-confirmed-email]').textContent = success ? state.email : '';
      modal.querySelector('[data-restock-marketing-error]').hidden = !state?.marketingFailed;
      requestError.hidden = state?.status !== 'error';
      submit.disabled = state?.status === 'pending' || !state?.ready && state?.status !== 'error';
      email.disabled = state?.status === 'pending';
      if (consent) consent.disabled = state?.status === 'pending';
      submit.textContent = submit.dataset[state?.status === 'pending' ? 'pending' : state?.status === 'error' ? 'retry' : 'default'];
      fieldError.hidden = true;
      email.removeAttribute('aria-invalid');
    }
    function fit() {
      if (!modal.open) return;
      const viewport = window.visualViewport;
      const height = viewport?.height || window.innerHeight;
      modal.style.maxHeight = Math.max(100, height - 32) + 'px';
      modal.style.top = ((viewport?.offsetTop || 0) + height / 2) + 'px';
    }
    async function open(button) {
      if (modal.open) save();
      const ownVersion = ++version;
      const variantId = button.dataset.variantId;
      if (!/^\d+$/.test(variantId || '')) return;
      const context = button.closest('[data-pdp], .product-card');
      const link = context?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = button.dataset.productHandle || context?.dataset.productHandle || link.match(/\/products\/([^/?#]+)/)?.[1] || '';
      const title = button.dataset.productTitle || context?.querySelector('h1, .product-card__title')?.textContent.trim() || '';
      trigger = button;
      if (!drafts.has(variantId)) drafts.set(variantId, {variantId, title, volume: button.dataset.productVolume || '', email:'',consent:false,status:'idle',ready:false});
      state = drafts.get(variantId);
      state.source = button.dataset.bisSource || 'pdp';
      state.title = title || state.title;
      state.ready = false;
      render();
      if (!modal.open) {previousOverflow = document.documentElement.style.overflow;modal.showModal();document.documentElement.style.overflow='hidden';}
      modal.querySelector('[data-restock-heading]').focus({preventScroll:true});
      fit();
      emit('bis:open');
      try {
        if (!handle) throw new Error('Missing product');
        const controller = new AbortController();
        const timeout = setTimeout(()=>controller.abort(),10000);
        let product;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/')+'products/'+encodeURIComponent(handle)+'.js',{signal:controller.signal,headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Product unavailable');
          product=await response.json();
        } finally {clearTimeout(timeout);}
        const variant = product.variants?.find(v=>String(v.id)===variantId);
        if (!variant) throw new Error('Variant unavailable');
        const draft=drafts.get(variantId);
        draft.title=title || product.title;
        draft.productId=String(product.id);
        draft.volume=button.dataset.productVolume || context?.querySelector('.pdp-size.is-selected .pdp-size__label')?.textContent.trim() || (variant.public_title || variant.title || '').replace(/^Default Title$/,'');
        draft.ready=true;
        if (version===ownVersion) {save();render();}
      } catch(error) {
        if (version===ownVersion) {save();state.status='error';render();}
      }
    }
    modal.addEventListener('close',()=>{
      save();
      version++;
      document.documentElement.style.overflow=previousOverflow;
      trigger?.focus({preventScroll:true});
    });
    let backdrop=false;
    modal.addEventListener('pointerdown',event=>{const r=modal.getBoundingClientRect();backdrop=event.target===modal&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom);});
    modal.addEventListener('click',event=>{if(backdrop&&event.target===modal)modal.close();backdrop=false;});
    document.addEventListener('click',event=>{
      const button=event.target.closest('[data-bis-trigger]');
      if(button){event.preventDefault();open(button);return;}
      if(modal.open&&event.target.closest('[data-bis-close]'))modal.close();
    });
    window.visualViewport?.addEventListener('resize',fit);
    window.visualViewport?.addEventListener('scroll',fit);
    async function send(path, body) {
      const controller=new AbortController();
      const timeout=setTimeout(()=>controller.abort(),15000);
      try {
        const response=await fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+encodeURIComponent(modal.dataset.companyId),{method:'POST',headers:{'Content-Type':'application/json',revision:'2026-07-15'},body:JSON.stringify(body),signal:controller.signal});
        if(response.status!==202)throw new Error('Request not confirmed');
      }finally{clearTimeout(timeout);}
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(!state||state.status==='pending')return;
      if(!state.ready){open(trigger);return;}
      email.value=email.value.trim();
      const valid=email.value&&email.checkValidity();
      if(!valid){fieldError.textContent=fieldError.dataset[email.value?'invalid':'missing'];fieldError.hidden=false;email.setAttribute('aria-invalid','true');email.focus();return;}
      save();
      const submitted=state;
      const address=submitted.email;
      const marketing=submitted.consent;
      const requestKey=submitted.variantId+':'+address.toLowerCase();
      submitted.status='pending';render();
      if(!requests.has(requestKey)){
        const body = {data: {
          type: 'back-in-stock-subscription',
          attributes: {profile: {data: {type: 'profile', attributes: {email: address}}}, channels: ['EMAIL']},
          relationships: {variant: {data: {type: 'catalog-variant', id: '$shopify:::$default:::' + submitted.variantId}}}
        }};
        const operation = accepted.has(requestKey) ? Promise.resolve() : send('back-in-stock-subscriptions', body);
        requests.set(requestKey,operation);
      }
      try{
        await requests.get(requestKey);
        accepted.add(requestKey);
        submitted.marketingFailed=false;
        if(marketing&&modal.dataset.listId){
          try {
            await send('subscriptions', {data: {
              type: 'subscription',
              attributes: {profile: {data: {type: 'profile', attributes: {
                email: address, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
              }}}},
              relationships: {list: {data: {type: 'list', id: modal.dataset.listId}}}
            }});
          } catch (error) { submitted.marketingFailed = true; }
        }
        submitted.status='success';
        document.dispatchEvent(new CustomEvent('bis:subscribed',{detail:{source:submitted.source,variant_id:submitted.variantId,marketing_opt_in:marketing,marketing_confirmed:marketing&&!submitted.marketingFailed,...window.HinokPairsAB?.properties()}}));
      }catch(error){submitted.status='error';}
      finally{requests.delete(requestKey);if(state===submitted)render();}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
